/**
 * OTP — Shipping timeline dates.
 *
 * The Liquid template already renders the correct dates on the server. This
 * script recalculates them in the browser so that a page served from cache on
 * a later day still shows today's date instead of the cached one.
 *
 * Business days = Monday..Friday. Public holidays are not accounted for.
 */

const OTP_WEEKDAYS = [
  'domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado',
];

/**
 * @param {Date} date
 * @returns {string} e.g. "terça, 01/09"
 */
function otpFormatDate(date) {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  return `${OTP_WEEKDAYS[date.getDay()]}, ${day}/${month}`;
}

/**
 * @param {Date} start
 * @param {number} amount number of business days to add
 * @returns {Date}
 */
function otpAddBusinessDays(start, amount) {
  const date = new Date(start.getTime());
  let added = 0;
  let guard = 0;

  while (added < amount && guard < 60) {
    date.setDate(date.getDate() + 1);
    const weekday = date.getDay();
    if (weekday !== 0 && weekday !== 6) added += 1;
    guard += 1;
  }

  return date;
}

class OtpShippingTimeline extends HTMLElement {
  connectedCallback() {
    this.render();
  }

  render() {
    const nodes = this.querySelectorAll('[data-otp-date]');
    if (nodes.length < 3) return;

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // 1 or 2 business days, alternating by day so it is not always the same.
    const prepDays = (Math.floor(Date.now() / 86400000) % 2) + 1;
    const shipDays = Number(this.dataset.shipDays) || 4;

    const dates = [
      today,
      otpAddBusinessDays(today, prepDays),
      otpAddBusinessDays(today, Math.max(shipDays, prepDays + 1)),
    ];

    nodes.forEach((node, index) => {
      const date = dates[index];
      if (!date) return;
      node.textContent = otpFormatDate(date);
      node.setAttribute('datetime', date.toISOString().slice(0, 10));
    });
  }
}

if (!customElements.get('otp-shipping-timeline')) {
  customElements.define('otp-shipping-timeline', OtpShippingTimeline);
}
